import Vue from 'vue'
import VueRouter from 'vue-router'
import hp from './hp'
import xwx from './xwx'
import Cookies from 'js-cookie'
import path from 'path-browserify'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [...hp, ...xwx]
})

router.beforeEach((to, from, next) => {
  // console.log(to);
  // let obj =[
  //   {
  //     name: '应用软件',
  //     path: '/company',
  //     keeplive: false
  //   }
  // ]
  // window.localStorage.setItem('routerlist',JSON.stringify(obj))
  // console.log(from);
  if (to.path == "/ordinaryUsers") {
    if (Cookies.get("token")) {
      next()
    } else {
      next("/login")
    }
  } else if (to.path == "/layout") {
    console.log(to);
    console.log(from);
    if (Cookies.get("token")) {
      console.log("objects.layout");
      next()
    } else {
      next("/login")
    }
  } else {
    next()
  }
})
router.afterEach((to,from)=>{
  // console.log(to);
  // var obj = JSON.parse(localStorage.getItem('routerlist'))
  // for(var i=0;i<obj.length;i++){
  //   if(obj[i].path != to.path){
  //     obj.push({name:to.name,path:to.path,keeplive:false})
  //   }else{
  //     obj[i].keeplive = true
  //   }
  // }
  // if(to.path != '/company'){
  //   obj.push({name:to.name,path:to.path})
  // }
  // console.log(obj)
  if(to.meta.title){
    document.title = to.meta.title
  }else{
    document.title = 'NC-Link社区'
  }
})

export default router
